export const UserSettingKeys = {
    USER_WIZARD_COMPLETE:"نمایش ویزارد",
    WEB_HOME_PAGE_ID:"صفحه اصلی اپ کاربر",
    CORPORATE_HOME_PAGE_ID:"صفحه اصلی اپ سازمان",
    PLACE_HOME_PAGE_ID:"صفحه اصلی اپ مرکز",
    USER_CHECKOUT_TYPE:"نوع پرداخت"
}
